import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { IPrivilegeTemplateModel } from '../model/privilege-template.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class PrivilegeTemplateApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Privileges/Templates`;
  }

  constructor(private http: HttpClient) {}

  loadPrivilegeTemplates(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IPrivilegeTemplateModel[]>> {
    let params = createFilterParams(currentFilter);

    if (currentFilter?.additional?.includeGloballyAvailableForProductOwners) {
      params = params.set(
        'includeGloballyAvailableForProductOwners',
        currentFilter.additional.includeGloballyAvailableForProductOwners
      );
    }
    if (currentFilter?.additional?.includeTenantRelated) {
      params = params.set('includeTenantRelated', currentFilter.additional.includeTenantRelated);
    }

    return this.http.get<ApiResponse<IPrivilegeTemplateModel[]>>(this.url, { params });
  }

  loadAllPrivilegeTemplates(): Observable<IdName[]> {
    const url = `${this.url}/All`;
    return this.http.get<IdName[]>(url);
  }

  loadPrivilegeTemplateById(id: string): Observable<IPrivilegeTemplateModel> {
    const url = `${this.url}/${id}`;
    return this.http.get<IPrivilegeTemplateModel>(url);
  }

  createPrivilegeTemplate(privilegeTemplate: IdName): Observable<IdName> {
    return this.http.post<IdName>(this.url, privilegeTemplate, { headers });
  }

  updatePrivilegeTemplate(privilegeTemplate: IdName): Observable<IdName> {
    const url = `${this.url}/${privilegeTemplate.id}`;
    return this.http.put<IdName>(url, privilegeTemplate, { headers });
  }

  deletePrivilegeTemplate(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
